import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  isRequiredIntegerGreaterThanOrEqual,
  makeIntegerRangeValidatorWithLabelsLower
} from 'utilities/validators.js';

import { round6 as round } from 'utilities/math';

import Input from 'components/Input';
import Dropdown from '../Dropdown';

const isGreaterThanTwo = isRequiredIntegerGreaterThanOrEqual(2);

class SettingsFormComponent extends React.PureComponent {
  isValidSuccessFirst = (value, { twoSampleProportion: { numberOfTrialsFirst } }) =>
    makeIntegerRangeValidatorWithLabelsLower(
      1,
      numberOfTrialsFirst,
      1,
      'Number of Trials for sample variable #1'
    )(value);

  isValidSuccessSecond = (value, { twoSampleProportion: { numberOfTrialsSecond } }) =>
    makeIntegerRangeValidatorWithLabelsLower(
      1,
      numberOfTrialsSecond,
      1,
      'Number of Trials for sample variable #2'
    )(value);

  formatFn = value => (value || value === 0 ? round(value) : '');

  listOfCategoricalVariables = this.props.getCategoricalOptionsDataSet();

  render () {
    const {
      firstVariable,
      secondVariable,
      getFirstLevelsOptions,
      getSecondLevelsOptions,
      onHandleOptionsChangeFirst,
      onHandleOptionsChangeSecond,
      onHandleInputsFirstVariable,
      onHandleInputsSecondVariable,
      getCategoricalOptionsDataSet,
      onHandleLevelsOptionsChangeFirst,
      onHandleLevelsOptionsChangeSecond
    } = this.props;
    return (
      <div>
        {
          this.listOfCategoricalVariables.length > 0
            ? (
              <>
                <Dropdown
                  isClearable
                  optionsList={getCategoricalOptionsDataSet(secondVariable)}
                  label="Sample Variable #1"
                  name="firstVariable"
                  placeholder="Select a Variable"
                  onChange={onHandleOptionsChangeFirst}
                  id="firstVariable"
                  labelClassName="font-900 font-14 mb-5"
                />
                <Dropdown
                  isClearable
                  isDisabled={!getFirstLevelsOptions.length}
                  optionsList={getFirstLevelsOptions}
                  label="Success Group"
                  name="successGroupFirst"
                  placeholder="Select a Variable"
                  onChange={onHandleLevelsOptionsChangeFirst}
                  id="successGroupFirst"
                />
              </>
            )
            : (
              <span className="font-14 font-900 mb-10">Sample Variable #1</span>
            )
        }
        <div className="flex space-between baseline">
          <Field
            type="number"
            id="numberOfSuccessFirst"
            component={Input}
            name="numberOfSuccessFirst"
            label="Number\nof Successes"
            pattern="\d+"
            wrapperClassName="mb-15 relative width-48 iconTop two-lines"
            inputClassName="main-input__input"
            onChange={onHandleInputsFirstVariable}
            format={this.formatFn}
            validate={this.isValidSuccessFirst}
          />

          <Field
            type="number"
            id="numberOfTrialsFirst"
            component={Input}
            name="numberOfTrialsFirst"
            label="Number\nof Trials"
            pattern="\d+"
            wrapperClassName="mb-15 relative width-48 iconTop two-lines"
            inputClassName="main-input__input"
            onChange={onHandleInputsFirstVariable}
            format={this.formatFn}
            validate={isGreaterThanTwo}
          />
        </div>
        {
          this.listOfCategoricalVariables.length > 1
            ? (
              <>
                <Dropdown
                  isClearable
                  optionsList={getCategoricalOptionsDataSet(firstVariable)}
                  label="Sample Variable #2"
                  name="secondVariable"
                  placeholder="Select a Variable"
                  onChange={onHandleOptionsChangeSecond}
                  id="secondVariable"
                  labelClassName="font-900 font-14 mb-5"
                />
                <Dropdown
                  isClearable
                  isDisabled={!getSecondLevelsOptions.length}
                  optionsList={getSecondLevelsOptions}
                  label="Success Group"
                  name="successGroupSecond"
                  placeholder="Select a Variable"
                  onChange={onHandleLevelsOptionsChangeSecond}
                  id="successGroupSecond"
                />
              </>
            )
            : (
              <span className="font-14 font-900 mb-10">Sample Variable #2</span>
            )
        }
        <div className="flex space-between baseline">
          <Field
            type="number"
            id="numberOfSuccessSecond"
            component={Input}
            name="numberOfSuccessSecond"
            label="Number\nof Successes"
            pattern="\d+"
            wrapperClassName="mb-15 relative width-48 iconTop two-lines"
            inputClassName="main-input__input"
            onChange={onHandleInputsSecondVariable}
            format={this.formatFn}
            validate={this.isValidSuccessSecond}
          />

          <Field
            type="number"
            id="numberOfTrialsSecond"
            component={Input}
            name="numberOfTrialsSecond"
            label="Number\nof Trials"
            pattern="\d+"
            wrapperClassName="mb-15 relative width-48 iconTop two-lines"
            inputClassName="main-input__input"
            onChange={onHandleInputsSecondVariable}
            format={this.formatFn}
            validate={isGreaterThanTwo}
          />
        </div>
      </div>
    );
  }
}

SettingsFormComponent.propTypes = {
  firstVariable: PropTypes.string.isRequired,
  secondVariable: PropTypes.string.isRequired,
  onHandleOptionsChangeFirst: PropTypes.func.isRequired,
  onHandleOptionsChangeSecond: PropTypes.func.isRequired,
  onHandleInputsFirstVariable: PropTypes.func.isRequired,
  onHandleInputsSecondVariable: PropTypes.func.isRequired,
  getCategoricalOptionsDataSet: PropTypes.func.isRequired,
  getFirstLevelsOptions: PropTypes.arrayOf(PropTypes.object),
  getSecondLevelsOptions: PropTypes.arrayOf(PropTypes.object),
  onHandleLevelsOptionsChangeFirst: PropTypes.func.isRequired,
  onHandleLevelsOptionsChangeSecond: PropTypes.func.isRequired
};

export default SettingsFormComponent;
